define(function (require) {

  var root = window;

  Model = root.Model = (root.Model || {});

  if (Model.t === undefined) {

    Model._ = {
      "boolean": "boolean",
      "number": "number",
      "string": "string",
      "undefined": undefined,
      "null": null,
      "array": "array",
      "object": "object",
      "function": "function",
      "empty": "empty",
      "get": "GET",
      "post": "POST",
      "delete": "DELETE",
      "put": "PUT"
    }

  }

  if (Model.structure === undefined) {

    var _ = Model._;

    Model.structure = {

      organ: {

        _name: {
          zh: "机构",
          en: ""
        },

        query_one: {
          url: "/api2/organizations",
          type: _.get,
          part: [true, _.string],
          param: {
            _required: false,
            verbose: [false, _.number]
          },
          _desc: {
            zh: {
              name: "查询机构"
            }
          }
        },

        query_list: {
          url: "/api2/organizations",
          type: _.get,
          param: {
            _required: false,
            verbose: [false, _.number],
            name: [false, _.string],
            state: [false, _.string],
            cursor: [false, _.number],
            limit: [false, _.number]
          },
          _desc: {
            zh: {
              name: "查询机构列表"
            }
          }
        },

        query_current: {
          url: "/api2/organizations/this",
          type: _.get,
          param: {
            _required: false,
            verbose: [false, _.number]
          },
          _desc: {
            zh: {
              name: "查询当前机构"
            }
          }
        },

        query_stat: {
          url: "/api2/organizations/stat",
          type: _.post,
          data: {
            _required: true,
            resourceIds: [true, _.array]
          },
          _desc: {
            zh: {
              name: "查询机构状态"
            }
          }
        },

        add: {
          url: "/api2/organizations",
          type: _.post,
          param: {
            _required: false,
            verbose: [false, _.number]
          },
          data: {
            _required: true,
            name: [true, _.string],
            email: [true, _.string],
            phone: [true, [_.string, _.number]],
            website: [false, _.string],
            fax: [false, [_.string, _.number]],
            address: [false, _.string],
            username: [true, _.string],
            cellPhone: [false, [_.string, _.number]],
            question: [true, [_.string, _.number]],
            answer: [true, [_.string, _.number]],
            photoFileld: [false, _.string],
            picId: [true, _.string],
            varificationCode: [true, _.string]
          },
          _desc: {
            zh: {
              name: "新增机构"
            }
          }
        },

        "delete": {
          url: "/api2/organizations",
          type: _["delete"],
          part: [true, _.string],
          _desc: {
            zh: {
              name: "删除机构"
            }
          }
        },

        update: {
          url: "/api2/organizations",
          type: _.put,
          part: [true, _.string],
          param: {
            _required: false,
            verbose: [false, _.number]
          },
          data: {
            _required: false,
            name: [false, _.string],
            email: [false, _.string],
            phone: [false, [_.string, _.number]],
            website: [false, _.string],
            fax: [false, [_.string, _.number]],
            address: [false, _.string],
            username: [false, _.string],
            cellPhone: [false, [_.string, _.number]],
            question: [false, [_.string, _.number]],
            answer: [false, [_.string, _.number]],
            photoFileld: [false, _.string],
            picId: [false, _.string],
            varificationCode: [false, _.string]
          },
          _desc: {
            zh: {
              name: "更新机构信息"
            }
          }
        },

        update_current: {
          url: "/api2/organizations/this",
          type: _.put,
          param: {
            _required: false,
            verbose: [false, _.number]
          },
          data: {
            _required: false,
            name: [false, _.string],
            email: [false, _.string],
            phone: [false, [_.string, _.number]],
            website: [false, _.string],
            fax: [false, [_.string, _.number]],
            address: [false, _.string],
            username: [false, _.string],
            cellPhone: [false, [_.string, _.number]],
            question: [false, [_.string, _.number]],
            answer: [false, [_.string, _.number]],
            photoFileld: [false, _.string],
            picId: [false, _.string],
            varificationCode: [false, _.string]
          },
          _desc: {
            zh: {
              name: "更新当前机构信息"
            }
          }
        }

      },

      site: {

        _name: {
          zh: "现场",
          en: ""
        },

        query_one: {
          url: "/api/sites",
          type: _.get,
          part: [true, _.string],
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          _desc: {
            zh: {
              name: "查询现场"
            }
          }
        },

        query_list: {
          url: "/api/sites",
          type: _.get,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string],
            cursor: [false, _.number],
            limit: [false, _.number],
            name: [false, _.string],
            address: [false, _.string],
            online: [false, _.number],
            has_gateway: [false, _.boolean],
            business_state: [false, _.string],
            is_alarm: [false, _.boolean],
            start_time: [false, _.number],
            end_time: [false, _.number]
          },
          _desc: {
            zh: {
              name: "查询现场列表"
            }
          }
        },

        query_devices_count: {
          url: "/api/sites/count",
          type: _.get,
          part: [true, _.string],
          param: {
            _required: false,
            oid: [true, _.string]
          },
          _desc: {
            zh: {
              name: "查询现场下设备"
            }
          }
        },

        add: {
          url: "/api/sites",
          type: _.post,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          data: {
            _required: true
          },
          _desc: {
            zh: {
              name: "新增现场"
            }
          }
        },

        "delete": {
          url: "/api/sites",
          type: _["delete"],
          part: [true, _.string],
          param: {
            _required: false,
            delete_all: [false, _.number],
            oid: [false, _.string]
          },
          _desc: {
            zh: {
              name: "删除现场"
            }
          }
        },

        update: {
          url: "/api/sites",
          type: _.put,
          part: [true, _.string],
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          data: {
            _required: true
          },
          _desc: {
            zh: {
              name: "更新现场信息"
            }
          }
        }

      },

      machine: {

        _name: {
          zh: "机器",
          en: ""
        },

        query_one: {
          url: "/api/machines",
          type: _.get,
          part: [true, _.string],
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          _desc: {
            zh: {
              name: "查询机器"
            }
          }
        },

        query_list: {
          url: "/api/machines",
          type: _.get,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string],
            cursor: [false, _.number],
            limit: [false, _.number],
            name: [false, _.string],
            plc_id: [false, _.number],
            site_id: [false, _.string],
            modelId: [false, _.string],
            serial_number: [false, _.string],
            start_time: [false, _.number],
            end_time: [false, _.number]
          },
          _desc: {
            zh: {
              name: "查询机器列表"
            }
          }
        },

        add: {
          url: "/api/machines",
          type: _.post,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          data: {
            _required: true
          },
          _desc: {
            zh: {
              name: "新增列表"
            }
          }
        },

        update: {
          url: "/api/machines",
          type: _.put,
          part: [true, _.string],
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string],
            cancel_site: [false, _.string]
          },
          data: {
            _required: true
          },
          _desc: {
            zh: {
              name: "更新机器信息"
            }
          }
        },

        "delete": {
          url: "/api/machines",
          type: _["delete"],
          part: [true, _.string],
          param: {
            _required: false,
            oid: [false, _.string]
          },
          _desc: {
            zh: {
              name: "删除机器"
            }
          }
        }

      },

      device: {

        _name: {
          zh: "设备",
          en: ""
        },

        query_one: {
          url: "/api/devices",
          type: _.get,
          part: [true, _.string],
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          _desc: {
            zh: {
              name: "查询设备"
            }
          }
        },

        query_list: {
          url: "/api/devices",
          type: _.get,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string],
            cursor: [false, _.number],
            limit: [false, _.number],
            name: [false, _.string],
            online: [false, _.number],
            plc_id: [false, _.number],
            site_id: [false, _.string],
            site_name: [false, _.string],
            model: [false, _.string],
            serial_number: [false, _.string],
            address: [false, _.string],
            business_state: [false, _.string],
            is_alarm: [false, _.boolean],
            start_time: [false, _.number],
            end_time: [false, _.number]
          },
          _desc: {
            zh: {
              name: "查询设备列表"
            }
          }
        },

        post_query_list: {
          url: "/api/devices/overview",
          type: _.post,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string],
            cursor: [false, _.number],
            limit: [false, _.number]
          },
          data: {
            _required: true,
            resourceIds: [true, _.array]
          },
          _desc: {
            zh: {
              name: "post查询设备列表"
            }
          }
        },

        query_organ: {
          url: "/api/devices",
          type: _.get,
          param: {
            _required: true,
            serial_number: [true, _.string]
          },
          _desc: {
            zh: {
              name: "查询设备所在机构"
            }
          }
        },

        query_site: {
          url: "/api/devices/batch_get",
          type: _.post,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string],
            cursor: [false, _.number],
            limit: [false, _.number],
            name: [false, _.string],
            online: [false, _.number],
            plc_id: [false, _.number],
            model: [false, _.string],
            serial_number: [false, _.string],
            address: [false, _.string],
            business_state: [false, _.string],
            start_time: [false, _.number],
            end_time: [false, _.number]
          },
          data: {
            _required: true,
            resourceIds: [true, _.array]
          },
          _desc: {
            zh: {
              name: "查询设备所属现场"
            }
          }
        },

        add: {
          url: "/api/devices",
          type: _.post,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string],
            create_site: [false, _.number]
          },
          data: {
            _required: true,
            name: [true, _.string],
            modelId: [true, _.string],
            serialNumber: [true, _.string],
            location: [true, _["object"]],
            model: [false, _.string],
            plcId: [false, _.number],
            maxPlcId: [false, _.number],
            maxSensorId: [false, _.number],
            mobileNumber: [false, _.number],
            timezone: [false, _.number],
            siteName: [false, _.string],
            siteId: [false, _.string],
            contact: [false, _["object"]],
            vendorId: [false, _.number],
            priIp: [false, _.string],
            pubIp: [false, _.string],
            priPort: [false, _.number],
            pubPort: [false, _.number],
            online: [false, _.number],
            syncState: [false, _.number],
            config: [false, _["object"]],
            info: [false, _["object"]],
            isMyFavorite: [false, _.number],
            alarmCount: [false, _.number],
            location: [false, _["object"]],
            deviceConfig: [false, _["object"]],
            address: [false, _.string],
            businessState: [false, _.number],
            owner: [false, _.string],
            createTime: [false, _.number],
            updateTime: [false, _.number]
          },
          _desc: {
            zh: {
              name: "新增设备"
            }
          }
        },

        "delete": {
          url: "/api/devices",
          type: _["delete"],
          part: [true, _.string],
          param: {
            _required: false,
            oid: [false, _.string]
          },
          _desc: {
            zh: {
              name: "删除设备"
            }
          }
        },

        update: {
          url: "/api/devices",
          type: _.put,
          part: [true, _.string],
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string],
            cancel_site: [false, _.string]
          },
          _desc: {
            zh: {
              name: "更新设备信息"
            }
          }
        },

        batch_add: {
          url: "/api/devices/batch_add",
          type: _.post,
          param: {
            _required: true,
            verbose: [false, _.number],
            oid: [false, _.string],
            create_site: [false, _.number],
            file_id: [true, _.string]
          },
          data: {
            _required: true,
            publicAttribute: [true, _["object"]]
          },
          _desc: {
            zh: {
              name: "批量增加设备"
            }
          }
        },

        batch_update: {
          url: "/api/devices/batch_update",
          type: _.post,
          param: {
            _required: true,
            verbose: [false, _.number],
            oid: [false, _.string],
            file_id: [true, _.string]
          },
          _desc: {
            zh: {
              name: "批量更新设备信息"
            }
          }
        },

        batch_delete: {
          url: "/api/devices/batch_delete",
          type: _.post,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          _desc: {
            zh: {
              name: "批量删除设备"
            }
          }
        }

      },

      model: {

        _name: {
          zh: "机型",
          en: ""
        },

        query_one: {
          url: "/api/models",
          type: _.get,
          part: [true, _.string],
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          _desc: {
            zh: {
              name: "查询机器"
            }
          }
        },

        query_list: {
          url: "/api/models",
          type: _.get,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string],
            cursor: [false, _.number],
            limit: [false, _.number],
            name: [false, _.string],
            start_time: [false, _.number],
            end_time: [false, _.number]
          },
          _desc: {
            zh: {
              name: "查询机器列表"
            }
          }
        },

        add: {
          url: "/api/models",
          type: _.post,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          data: {
            _required: true,
            configFile: [true, _.string],
            sensorType: [true, _.number],
            model: [true, _.string],
            name: [true, _.string],
            gateway: [false, _.boolean],
            accessProto: [false, _.string],
            firmwareProto: [false, _.string],
            sensorType: [false, _.number],
            ioType: [false, _.number],
            plcTypeId: [false, _.number],
            "delete": [false, _.number],
            isMyFavorite: [false, _.number],
            icon: [false, _.string],
            descriptions: [false, _["object"]],
            pics: [false, _.array],
            views: [false, _.array],
            owner: [false, _.string],
            createTime: [false, _.number],
            createTime: [false, _.number]
          },
          _desc: {
            zh: {
              name: "新增机器"
            }
          }
        },

        "delete": {
          url: "/api/models",
          type: _["delete"],
          part: [true, _.string],
          param: {
            _required: false,
            oid: [false, _.string]
          },
          _desc: {
            zh: {
              name: "删除机器"
            }
          }
        },

        update: {
          url: "/api/models",
          type: _.put,
          part: [true, _.string],
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          _desc: {
            zh: {
              name: "更新机器信息"
            }
          }
        }

      },

      history: {

        _name: {
          zh: "历史数据",
          en: ""
        },

        query_devices: {
          url: "/api/data",
          type: _.post,
          param: {
            _required: false,
            oid: [false, _.string],
            start_time: [true, _.number],
            end_time: [true, _.number]
          },
          data: {
            _required: false,
            devices: [false, _.array]
          },
          _desc: {
            zh: {
              name: "查询设备历史数据"
            }
          }
        }

      },

      tag: {

        _name: {
          zh: "标签",
          en: ""
        },

        query_one: {
          url: "/api/tags",
          type: _.get,
          part: [true, _.string],
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          _desc: {
            zh: {
              name: "查询标签"
            }
          }
        },

        query_list: {
          url: "/api/tags",
          type: _.get,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string],
            cursor: [false, _.number],
            limit: [false, _.number],
            name: [false, _.string],
            shared: [false, _.boolean]
          },
          _desc: {
            zh: {
              name: "查询标签列表"
            }
          }
        },

        query_resource_tags: {
          url: "/api/resource_tags",
          type: _.get,
          param: {
            _required: false,
            oid: [false, _.string],
            resource_type: [false, _.number],
            resource_id: [false, _.string],
            cursor: [false, _.number],
            limit: [false, _.number]
          },
          _desc: {
            zh: {
              name: "查询批量资源所属标签"
            }
          }
        },

        query_resources_tags: {
          url: "/api/resources_tags",
          type: _.get,
          param: {
            _required: false,
            oid: [false, _.string]
          },
          data: {
            _required: true,
            resourceIds: [true, _.array]
          },
          _desc: {
            zh: {
              name: "查询资源所属标签"
            }
          }
        },

        query_tag: {
          url: "/api/tags",
          type: _.get,
          part: [true, _.string],
          suffix: "/resources",
          param: {
            _required: false,
            oid: [false, _.string],
            resource_type: [false, _.number],
            cursor: [false, _.number],
            limit: [false, _.number]
          },
          _desc: {
            zh: {
              name: "查询标签下的资源"
            }
          }
        },

        query_count: {
          url: "/api/resource_tags/stat",
          type: _.post,
          param: {
            _required: false,
            oid: [false, _.string],
            cursor: [false, _.number],
            limit: [false, _.number]
          },
          data: {
            _required: true,
            resourceTypes: [true, _.array],
            tagIds: [true, _.array]
          },
          _desc: {
            zh: {
              name: "查询标签统计"
            }
          }
        },

        add: {
          url: "/api/tags",
          type: _.post,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          data: {
            _required: true,
            name: [true, _.string],
            shared: [true, _.boolean],
            owner: [false, _.string],
            createTime: [false, _.number],
            updateTime: [false, _.number]
          },
          _desc: {
            zh: {
              name: "新增标签"
            }
          }
        },

        tag_resource: {
          url: "/api/resource_tags",
          type: _.put,
          param: {
            _required: true,
            oid: [false, _.string],
            resource_type: [true, _.number],//类型待定
            resource_id: [true, _.string],
            tag_id: [true, _.string]
          },
          _desc: {
            zh: {
              name: "给资源打标签"
            }
          }
        },

        tag_resources: {
          url: "/api/resources_tags",
          type: _.put,
          param: {
            _required: true,
            oid: [false, _.string],
            tag_id: [true, _.string]
          },
          data: {
            _required: true,
            resourceIds: [true, _.array]
          },
          _desc: {
            zh: {
              name: "给批量资源打标签"
            }
          }
        },

        tag_resources_tags: {
          url: "/api/resources_multiple_tags",
          type: _.post,
          param: {
            _required: false,
            oid: [false, _.string]
          },
          data: {
            _required: true,
            resourceTags: [true, _.array],
            resourceId: [true, _.string],
            tagIds: [true, _.array]
          },
          _desc: {
            zh: {
              name: "给批量资源打批量标签"
            }
          }
        },

        "delete": {
          url: "/api/tags",
          type: _["delete"],
          part: [true, _.string],
          param: {
            _required: false,
            oid: [false, _.string]
          },
          _desc: {
            zh: {
              name: "删除标签"
            }
          }
        },

        delete_resource_tag: {
          url: "/api/resource_tags",
          type: _["delete"],
          param: {
            _required: true,
            oid: [false, _.string],
            resource_id: [true, _.string],
            tag_id: [true, _.string]
          },
          _desc: {
            zh: {
              name: "删除资源的标签"
            }
          }
        },

        delete_resources_tags: {
          url: "/api/resources_multiple_tags",
          type: _.put,
          param: {
            _required: false,
            oid: [false, _.string]
          },
          data: {
            _required: true,
            resourceTags: [true, _.array],
            resourceId: [true, _.string],
            tagIds: [true, _.array]
          },
          _desc: {
            zh: {
              name: "删除批量资源的标签"
            }
          }
        },

        update: {
          url: "/api/tags",
          type: _.put,
          part: [true, _.string],
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          data: {
            _required: false,
            name: [false, _.string],
            shared: [false, _.boolean],
            owner: [false, _.string],
            createTime: [false, _.number],
            updateTime: [false, _.number]
          },
          _desc: {
            zh: {
              name: "更新标签"
            }
          }
        },

        query_user: {
          url: "/api/user_tags",
          type: _.get,
          param: {
            _required: false,
            oid: [false, _.string],
            cursor: [false, _.number],
            limit: [false, _.number]
          },
          _desc: {
            zh: {
              name: "查询用户的标签"
            }
          }
        },

        query_role: {
          url: "/api/role_tags",
          type: _.get,
          param: {
            _required: false,
            oid: [false, _.string],
            cursor: [false, _.number],
            limit: [false, _.number]
          },
          _desc: {
            zh: {
              name: "查询角色的标签"
            }
          }
        },

        query_device: {
          url: "/api/device_tags",
          type: _.get,
          param: {
            _required: false,
            oid: [false, _.string],
            cursor: [false, _.number],
            limit: [false, _.number]
          },
          _desc: {
            zh: {
              name: "查询设备的标签"
            }
          }
        },

        query_site: {
          url: "/api/site_tags",
          type: _.get,
          param: {
            _required: false,
            oid: [false, _.string],
            cursor: [false, _.number],
            limit: [false, _.number]
          },
          _desc: {
            zh: {
              name: "查询现场的标签"
            }
          }
        },

        query_model: {
          url: "/api/model_tags",
          type: _.get,
          param: {
            _required: false,
            oid: [false, _.string],
            cursor: [false, _.number],
            limit: [false, _.number]
          },
          _desc: {
            zh: {
              name: "查询机型的标签"
            }
          }
        },

        query_document: {
          url: "/api/document_tags",
          type: _.get,
          param: {
            _required: false,
            oid: [false, _.string],
            cursor: [false, _.number],
            limit: [false, _.number]
          },
          _desc: {
            zh: {
              name: "查询文档的标签"
            }
          }
        },

        query_customer: {
          url: "/api/customer_tags",
          type: _.get,
          param: {
            _required: false,
            oid: [false, _.string],
            cursor: [false, _.number],
            limit: [false, _.number]
          },
          _desc: {
            zh: {
              name: "查询客户的标签"
            }
          }
        },

        query_none: {
          url: "/api/tags/none/resources",
          type: _.get,
          param: {
            _required: false,
            oid: [false, _.string],
            cursor: [false, _.number],
            limit: [false, _.number]
          },
          _desc: {
            zh: {
              name: "查询没有资源的标签"
            }
          }
        }

      },

      statistics: {

        _name: {
          zh: "在线统计",
          en: ""
        },

        query_online: {
          url: "/api/online_stat",
          type: _.get,
          param: {
            _required: false,
            oid: [false, _.string],
            start_time: [false, _.number],
            end_time: [false, _.number]
          },
          _desc: {
            zh: {
              name: "查询在线统计"
            }
          }
        },

        query_online_trend: {
          url: "/api/online_tendency",
          type: _.post,
          param: {
            _required: true,
            start_time: [true, _.number],
            end_time: [true, _.number]
          },
          data: {
            _required: true,
            resourceIds: [true, _.array]
          },
          _desc: {
            zh: {
              name: "查询在线曲线"
            }
          }
        },

        query_month_traffic: {
          url: "/api/traffic_month",
          type: _.get,
          param: {
            _required: true,
            month: [true, _.number]
          },
          _desc: {
            zh: {
              name: "查询月流量"
            }
          }
        },

        query_day_traffic: {
          url: "/api/traffic_day",
          type: _.get,
          param: {
            _required: true,
            month: [true, _.number],
            device_id: [true, _.string]
          },
          _desc: {
            zh: {
              name: "日流量"
            }
          }
        },

        query_traffic: {
          url: "/api/traffic",
          type: _.post,
          param: {
            _required: false,
            start_time: [false, _.number],
            end_time: [false, _.number]
          },
          data: {
            _required: true,
            deviceIds: [true, _.array]
          },
          _desc: {
            zh: {
              name: "查询流量"
            }
          }
        },

        query_signal: {
          url: "/api2/signal",
          type: _.post,
          param: {
            _required: true,
            start_time: [true, _.number],
            end_time: [true, _.number]
          },
          data: {
            _required: true,
            resourceIds: [true, _.array]
          },
          _desc: {
            zh: {
              name: "查询信号值"
            }
          }
        }

      },

      user: {

        _name: {
          zh: "用户",
          en: ""
        },

        query_one: {
          url: "/api2/users",
          type: _.get,
          part: [true, _.string],
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          _desc: {
            zh: {
              name: "查询用户"
            }
          }
        },

        query_list: {
          url: "/api2/users",
          type: _.get,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string],
            cursor: [false, _.number],
            limit: [false, _.number],
            name: [false, _.string],
            role_ids: [false, _.string]
          },
          _desc: {
            zh: {
              name: "查询用户列表"
            }
          }
        },

        query_list_post: {
          url: "/api2/users/list",
          type: _.post,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string],
            cursor: [false, _.number],
            limit: [false, _.number],
            name: [false, _.string],
            role_ids: [false, _.string]
          },
          data: {
            _required: true,
            resourceIds: [true, _.array]
          },
          _desc: {
            zh: {
              name: "post查询用户列表"
            }
          }
        },

        query_current: {
          url: "/api2/users/this",
          type: _.get,
          param: {
            _required: false,
            verbose: [false, _.number]
          },
          _desc: {
            zh: {
              name: "查询当前用户"
            }
          }
        },

        add: {
          url: "/api2/users",
          type: _.post,
          param: {
            _required: false,
            verbose: [false, _.number]
          },
          data: {
            _required: true,
            email: [true, _.string],
            roleId: [true, _.string],
            name: [true, _.string],
            password: [false, _.string],
            phone: [false, _.string],
            photoFileld: [false, _.string],
            owner: [false, _.string],
            question: [false, _.string],
            answer: [false, _.string]
          },
          _desc: {
            zh: {
              name: "新增用户"
            }
          }
        },

        "delete": {
          url: "/api2/users",
          type: _["delete"],
          part: [true, _.string],
          param: {
            _required: false,
            oid: [false, _.string]
          },
          _desc: {
            zh: {
              name: "删除用户"
            }
          }
        },

        update: {
          url: "/api2/users",
          type: _.put,
          part: [true, _.string],
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          data: {
            _required: false,
            email: [false, _.string],
            roleId: [false, _.string],
            name: [false, _.string],
            password: [false, _.string],
            phone: [false, _.string],
            photoFileld: [false, _.string],
            owner: [false, _.string],
            question: [false, _.string],
            answer: [false, _.string]
          },
          _desc: {
            zh: {
              name: "更新用户信息"
            }
          }
        },

        update_current: {
          url: "/api2/users/this",
          type: _.put,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          data: {
            _required: false,
            email: [false, _.string],
            roleId: [false, _.string],
            name: [false, _.string],
            password: [false, _.string],
            phone: [false, _.string],
            photoFileld: [false, _.string],
            owner: [false, _.string],
            question: [false, _.string],
            answer: [false, _.string]
          },
          _desc: {
            zh: {
              name: "更新当前用户信息"
            }
          }
        },

        update_owner: {
          url: "/api2/users",
          type: _.put,
          part: [true, _.string],
          suffix: "/owner",
          param: {
            _required: true,
            verbose: [false, _.number],
            oid: [false, _.string],
            owner: [true, _.string]
          },
          _desc: {
            zh: {
              name: "更新？？"
            }
          }
        },

        update_role: {
          url: "/api2/users",
          type: _.put,
          part: [true, _.string],
          suffix: "/role",
          param: {
            _required: true,
            verbose: [false, _.number],
            oid: [false, _.string],
            role_ids: [true, _.array]//类型待定
          },
          _desc: {
            zh: {
              name: "更新角色"
            }
          }
        },

        update_password: {
          url: "/api2/users",
          type: _.put,
          part: [true, _.string],
          suffix: "/password",
          param: {
            _required: false,
            oid: [false, _.string]
          },
          data: {
            _required: true,
            oldPassword: [true, [_.string, _.number]],
            newPassword: [true, [_.string, _.number]],
            phone: [false, [_.string, _.number]]
          },
          _desc: {
            zh: {
              name: "更改密码"
            }
          }
        },

        update_current_password: {
          url: "/api2/users/this/password",
          type: _.put,
          param: {
            _required: false,
            oid: [false, _.string]
          },
          data: {
            _required: true,
            oldPassword: [true, [_.string, _.number]],
            newPassword: [true, [_.string, _.number]],
            phone: [false, [_.string, _.number]]
          }
          ,
          _desc: {
            zh: {
              name: "更新当前用户的密码"
            }
          }
        },

        reset_password: {
          url: "/api2/users",
          type: _.put,
          part: [true, _.string],
          suffix: "/reset_password",
          param: {
            _required: true,
            oid: [false, _.string],
            language: [true, _.number]
          },
          data: {
            _required: true,
            phone: [false, [_.string, _.number]],
            picId: [true, [_.string, _.number]],
            varificationCode: [true, [_.string, _.number]]
          },
          _desc: {
            zh: {
              name: "重置用户密码"
            }
          }
        },

        reset_current_password: {
          url: "/api2/users/this/reset_password",
          type: _.put,
          param: {
            _required: true,
            oid: [false, _.string],
            language: [true, _.number]
          },
          data: {
            _required: true,
            phone: [false, [_.string, _.number]],
            picId: [true, [_.string, _.number]],
            varificationCode: [true, [_.string, _.number]]
          },
          _desc: {
            zh: {
              name: "重置当前用户用户"
            }
          }
        },

        forgot_password: {
          url: "/api/forgotten_password",
          type: _.post,
          param: {
            _required: true,
            language: [true, _.number]
          },
          data: {
            _required: true,
            username: [true, _.string],
            picId: [true, _.string],
            varificationCode: [true, _.string]
          },
          _desc: {
            zh: {
              name: "忘记密码"
            }
          }
        },

        query_privilege: {
          url: "/api2/users/this/privilege",
          type: _.get,
          param: {
            _required: true,
            oid: [false, _.number]
          },
          _desc: {
            zh: {
              name: "获取权限表"
            }
          }
        },

        _logout: {
          url: "/api2/logout",
          type: _.get,
          param: {
            _required: false,
            oid: [false, _.string]
          },
          _desc: {
            zh: {
              name: "退出登录"
            }
          }
        }

      },

      role: {

        _name: {
          zh: "角色",
          en: ""
        },

        query_one: {
          url: "/api2/roles",
          type: _.get,
          part: [true, _.string],
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          _desc: {
            zh: {
              name: "查询角色"
            }
          }
        },

        query_list: {
          url: "/api2/roles",
          type: _.get,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string],
            cursor: [false, _.number],
            limit: [false, _.number],
            name: [false, _.string]
          },
          _desc: {
            zh: {
              name: "查询角色列表"
            }
          }
        },

        add: {
          url: "/api2/roles",
          type: _.post,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          data: {
            _required: true,
            name: [true, _.string],
            type: [true, _.number],
            privileges: [false, _["object"]]//类型待定
          },
          _desc: {
            zh: {
              name: "新增角色"
            }
          }
        },

        "delete": {
          url: "/api2/roles",
          type: _["delete"],
          param: {
            _required: false,
            oid: [false, _.string]
          },
          _desc: {
            zh: {
              name: "删除角色"
            }
          }
        },

        update: {
          url: "/api2/roles",
          type: _.put,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          data: {
            _required: false,
            name: [false, _.string],
            type: [false, _.number],
            privileges: [false, _["object"]]//类型待定
          },
          _desc: {
            zh: {
              name: "更新角色信息"
            }
          }
        }

      },

      customer: {

        _name: {
          zh: "客户",
          en: ""
        },

        query_one: {
          url: "/api/customers",
          type: _.get,
          part: [true, _.string],
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          _desc: {
            zh: {
              name: "查询客户"
            }
          }

        },

        query_list: {
          url: "/api/customers",
          type: _.get,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string],
            cursor: [false, _.number],
            limit: [false, _.number],
            name: [false, _.string],
            start_time: [false, _.number],
            end_time: [false, _.number]
          },
          _desc: {
            zh: {
              name: "查询客户列表"
            }
          }
        },

        query_sites_count: {
          url: "/api/customers",
          type: _.get,
          part: [true, _.string],
          param: {
            _required: false,
            oid: [false, _.string]
          },
          _desc: {
            zh: {
              name: "？？"
            }
          }
        },

        add: {
          url: "/api2/customers",
          type: _.post,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          data: {
            _required: true,
            name: [true, _.string],
            email: [true, _.string],
            phone: [false, [_.string, _.number]],
            address: [false, _.string],
            webSite: [false, _.string],
            isMyFavorite: [false, _.number],
            siteCount: [false, _.number],
            siteIdList: [false, _.array],
            contact: [false, _["object"]],//类型待定
            owner: [false, _.string],
            createTime: [false, _.number],
            updateTime: [false, _.number]
          },
          _desc: {
            zh: {
              name: "新增用户"
            }
          }
        },

        "delete": {
          url: "/api/customers",
          type: _["delete"],
          part: [true, _.string],
          param: {
            _required: false,
            oid: [false, _.string]
          },
          _desc: {
            zh: {
              name: "删除用户"
            }
          }
        },

        update: {
          url: "/api/customers",
          type: _.put,
          part: [true, _.string],
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          data: {
            _required: false,
            name: [false, _.string],
            email: [false, _.string],
            phone: [false, [_.string, _.number]],
            address: [false, _.string],
            webSite: [false, _.string],
            isMyFavorite: [false, _.number],
            siteCount: [false, _.number],
            siteIdList: [false, _.array],
            contact: [false, _["object"]],//类型待定
            owner: [false, _.string],
            createTime: [false, _.number],
            updateTime: [false, _.number]
          },
          _desc: {
            zh: {
              name: "更新用户信息"
            }
          }
        }

      },

      task: {

        _name: {
          zh: "任务",
          en: ""
        },

        query_one: {
          url: "/api2/tasks",
          type: _.get,
          part: [true, _.string],
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          _desc: {
            zh: {
              name: "查询任务"
            }
          }
        },

        query_list: {
          url: "/api2/tasks",
          type: _.get,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string],
            cursor: [false, _.number],
            limit: [false, _.number],
            states: [false, _.array],
            user_types: [false, _.array],
            types: [false, _.array],
            object_id: [false, _.string],
            object_id_list: [false, _.array]
          },
          _desc: {
            zh: {
              name: "查询任务列表"
            }
          }
        },

        add: {
          url: "/api2/tasks",
          type: _.post,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          data: {
            _required: true,
            userType: [true, _.number],
            name: [true, _.string],
            type: [true, _.number],
            priority: [true, _.number],
            oid: [false, _.string],
            uid: [false, _.string],
            objectId: [false, _.string],
            objectName: [false, _.string],
            username: [false, _.string],
            cycle: [false, _.array],
            state: [false, _.number],
            progress: [false, _.number],
            siteId: [false, _.string],
            siteName: [false, _.string],
            create: [false, _.number],
            startTime: [false, _.number],
            updateTime: [false, _.number],
            desc: [false, [_.string, _.number]],
            error: [false, _.string],
            data: [false, _["object"]]
          },
          _desc: {
            zh: {
              name: "新增任务"
            }
          }
        },

        update: {
          url: "/api2/tasks",
          type: _.put,
          part: [true, _.string],
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          data: {
            _required: false,
            userType: [false, _.number],
            name: [false, _.string],
            type: [false, _.number],
            priority: [false, _.number],
            oid: [false, _.string],
            uid: [false, _.string],
            objectId: [false, _.string],
            objectName: [false, _.string],
            username: [false, _.string],
            cycle: [false, _.array],
            state: [false, _.number],
            progress: [false, _.number],
            siteId: [false, _.string],
            siteName: [false, _.string],
            create: [false, _.number],
            startTime: [false, _.number],
            updateTime: [false, _.number],
            desc: [false, [_.string, _.number]],
            error: [false, _.string],
            data: [false, _["object"]]
          },
          _desc: {
            zh: {
              name: "更新任务"
            }
          }
        },

        change_state: {
          url: "/api2/tasks",
          type: _.put,
          part: [true, _.string],
          suffix: "/status",
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string],
            status: [false, _.number]
          },
          _desc: {
            zh: {
              name: "改变任务状态"
            }
          }
        },

        "delete": {
          url: "/api2/tasks",
          type: _["delete"],
          part: [true, _.string],
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          _desc: {
            zh: {
              name: "删除任务"
            }
          }
        },

        delete_tasks: {
          url: "/api2/tasks",
          type: _["delete"],
          param: {
            _required: true,
            oid: [false, _.string],
            Object_id: [true, _.string],//属性名未确认
            types: [true, _.array]
          },
          _desc: {
            zh: {
              name: "查询任务"
            }
          }
        }

      },

      oauth: {

        _name: {
          zh: "认证",
          en: ""
        },

        get_token: {
          url: "/oauth2/access_token",
          type: _.post,
          data: {
            _required: true,
            client_secret: [true, _.string]
          },
          param: {
            _required: true,
            client_id: [true, _.string],
            client_secret: [true, _.string],
            grant_type: [true, _.string],
            username: [true, _.string],
            password: [true, _.string],
            language: [true, _.number]
          },
          _desc: {
            zh: {
              name: "获取令牌"
            }
          }
        },

        refresh_token: {
          url: "/oauth2/access_token",
          type: _.post,
          data: {
            _required: true,
            client_id: [true, _.string],
            client_secret: [true, _.string],
            grant_type: [true, _.string],
            refresh_token: [true, _.string]
          },
          _desc: {
            zh: {
              name: "刷新令牌"
            }
          }
        },

        get_token_info: {
          url: "/oauth2/get_token_info",
          type: _.get,
          _desc: {
            zh: {
              name: "获取令牌信息"
            }
          }
        }

      },

      captchas: {

        _name: {
          zh: "验证码",
          en: ""
        },

        get: {
          url: "/api/captchas",
          type: _.get,
          _desc: {
            zh: {
              name: "获取验证码"
            }
          }
        },

        img: {
          url: "/api/captchas",
          type: _.get,
          part: [true, _.string],
          _desc: {
            zh: {
              name: "获取验证码图片地址"
            }
          }
        },

        check: {
          url: "/api/captchas",
          type: _.post,
          data: {
            _required: true,
            pictureId: [true, _.string],
            code: [true, _.string]
          },
          _desc: {
            zh: {
              name: "验证验证码"
            }
          }
        }

      },

      app: {

        _name: {
          zh: "应用",
          en: ""
        },

        query_one: {
          url: "/api/apps",
          type: _.get,
          part: [true, _.string],
          param: {
            _required: false,
            verbose: [false, _.number]
          },
          _desc: {
            zh: {
              name: "查询应用"
            }
          }
        },

        query_list: {
          url: "/api/apps",
          type: _.get,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string],
            types: [false, _.array],
            classes: [false, _.array],
            cursor: [false, _.number],
            limit: [false, _.number],
            name: [false, _.string]
          },
          _desc: {
            zh: {
              name: "获取应用列表"
            }
          }
        },

        add: {
          url: "/api/apps",
          type: _.post,
          param: {
            _required: false,
            verbose: [false, _.number]
          },
          data: {
            _required: true,
            type: [true, _.string],
            "class": [true, _.string],
            file: [true, _.string]
          },
          _desc: {
            zh: {
              name: "新增应用"
            }
          }
        },

        update: {
          url: "/api/apps",
          type: _.put,
          part: [true, _.string],
          param: {
            _required: false,
            verbose: [false, _.number]
          },
          data: {
            _required: true
          },
          _desc: {
            zh: {
              name: "更新应用"
            }
          }
        }

      },

      alarm: {

        _name: {
          zh: "告警",
          en: ""
        },

        query: {
          url: "/api/alarms",
          type: _.get,
          param: {
            _required: false,
            verbose: [false, _.number],
            site_name: [false, _.string],
            sourc_name: [false, _.string],
            cursor: [false, _.number],
            limit: [false, _.number],
            types: [false, _.array],
            levels: [false, _.array],
            states: [false, _.array],
            start_time: [false, _.number],
            end_time: [false, _.number]
          },
          _desc: {
            zh: {
              name: "查询告警"
            }
          }
        },

        confirm: {
          url: "/api/alarms",
          type: _.put,
          part: [true, _.string],
          param: {
            _required: false,
            verbose: [false, _.number]
          },
          _desc: {
            zh: {
              name: "确认告警"
            }
          }
        },

        cancel: {
          url: "/api/alarms",
          type: _["delete"],
          part: [true, _.string],
          param: {
            _required: false,
            verbose: [false, _.number]
          },
          _desc: {
            zh: {
              name: "取消告警"
            }
          }
        },

        query_state: {
          url: "/api/alarm_stat",
          type: _.get,
          param: {
            _required: true,
            types: [false, _.array],
            levels: [false, _.array],
            states: [false, _.array],
            start_time: [true, _.number],
            end_time: [true, _.number]
          },
          _desc: {
            zh: {
              name: "查询告警状态"
            }
          }
        },

        query_trend: {
          url: "/api/alarm_trend",
          type: _.get,
          param: {
            _required: true,
            types: [false, _.array],
            levels: [false, _.array],
            states: [false, _.array],
            start_time: [true, _.number],
            end_time: [true, _.number]
          },
          _desc: {
            zh: {
              name: "查询告警曲线"
            }
          }
        },

        query_count: {
          url: "/api/alarm_count",
          type: _.post,
          param: {
            _required: false,
            types: [false, _.array],
            levels: [false, _.array],
            states: [false, _.array],
            oid: [false, _.string]
          },
          _desc: {
            zh: {
              name: "查询告警统计"
            }
          }
        }

      },

      reports: {

        _name: {
          zh: "报表",
          en: ""
        },

        get_forms: {
          url: "/api/reports/forms",
          type: _.get,
          param: {
            _required: false,
            oid: [false, _.string],
            report_name: [false, _.string],
            cursor: [false, _.number],
            limit: [false, _.number]
          },
          _desc: {
            zh: {
              name: "获取报表"
            }
          }
        }

      },

      favor: {

        _name: {
          zh: "收藏",
          en: ""
        },

        batch_add: {
          url: "/api/favorites",
          type: _.post,
          data: {
            _required: true,
            resourceId: [true, _.array]
          },
          _desc: {
            zh: {
              name: "批量添加收藏"
            }
          }
        },

        "delete": {
          url: "/api/favorites",
          type: _["delete"],
          part: [true, _.string],
          _desc: {
            zh: {
              name: "删除收藏"
            }
          }
        },

        query_list: {
          url: "/api/favorites",
          type: _.get,
          param: {
            _required: false,
            cursor: [false, _.number],
            limit: [false, _.number]
          },
          _desc: {
            zh: {
              name: "批量查询收藏"
            }
          }
        },

        check: {
          url: "/api/favorites/mine",
          type: _.post,
          param: {
            _required: false,
            oid: [false, _.string]
          },
          data: {
            _required: true,
            ids: [true, _.array]
          },
          _desc: {
            zh: {
              name: "查询收藏状态"
            }
          }
        }

      },

      log: {

        _name: {
          zh: "日志",
          en: ""
        },

        query_behav: {
          url: "/api2/behav_log",
          type: _.get,
          param: {
            _required: true,
            oid: [false, _.string],
            cursor: [false, _.number],
            limit: [false, _.number],
            level: [false, _.array],
            language: [true, _.number],
            start_time: [false, _.number],
            end_time: [false, _.number],
            username: [false, _.string]
          },
          _desc: {
            zh: {
              name: "查询操作日志"
            }
          }
        },

        query_comm: {
          url: "/api2/comm_log",
          type: _.get,
          param: {
            _required: true,
            oid: [false, _.string],
            cursor: [false, _.number],
            limit: [false, _.number],
            level: [false, _.array],
            language: [true, _.number],
            start_time: [false, _.number],
            end_time: [false, _.number],
            username: [false, _.string]
          },
          _desc: {
            zh: {
              name: "查询通信日志"
            }
          }
        }

      },

      realtime: {

        _name: {
          zh: "实时数据",
          en: ""
        },

        query_devices: {
          url: "/api/devices",
          type: _.get,
          part: [true, _.string],
          suffix: "/rt_data",
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string],
            filter: [false, _.string]
          },
          _desc: {
            zh: {
              name: "查询设备实时数据"
            }
          }
        },

        query_machines: {
          url: "/api/machines",
          type: _.get,
          part: [true, _.string],
          suffix: "/rt_data",
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string],
            filter: [false, _.string]
          },
          _desc: {
            zh: {
              name: "查询机器实时数据"
            }
          }
        },

        query_sites: {
          url: "/api/sites",
          type: _.get,
          part: [true, _.string],
          suffix: "/rt_data",
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string],
            filter: [false, _.string]
          },
          _desc: {
            zh: {
              name: "查询现场实时数据"
            }
          }
        }

      },

      group: {

        _name: {
          zh: "权限分组",
          en: ""
        },

        query_one: {
          url: "/api2/groups",
          type: _.get,
          part: [true, _.string],
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          _desc: {
            zh: {
              name: "查询分组"
            }
          }
        },

        query_list: {
          url: "/api2/groups",
          type: _.get,
          param: {
            _required: false,
            cursor: [false, _.number],
            limit: [false, _.number],
            name: [false, _.string],
            verbose: [false, _.number],
            oid: [false, _.string],
            uid: [false, _.string]
          },
          _desc: {
            zh: {
              name: "查询分组列表"
            }
          }
        },

        add: {
          url: "/api2/groups",
          type: _.post,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string]
          },
          data: {
            _required: true
          },
          _desc: {
            zh: {
              name: "新增分组"
            }
          }
        },

        update: {
          url: "/api2/groups",
          type: _.put,
          part: [true, _.string],
          param: {
            _required: false,
            oid: [false, _.string]
          },
          data: {
            _required: true
          },
          _desc: {
            zh: {
              name: "更新分组"
            }
          }
        },

        "delete": {
          url: "/api2/groups",
          type: _["delete"],
          part: [true, _.string],
          param: {
            _required: false,
            oid: [false, _.string]
          },
          _desc: {
            zh: {
              name: "删除分组"
            }
          }
        },

        query_group_resources: {
          url: "/api2/groups",
          type: _.get,
          part: [true, _.string],
          suffix: "/resources",
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string],
            type: [true, _.number],
            cursor: [false, _.number],
            limit: [false, _.number]
          },
          _desc: {
            zh: {
              name: "查询分组下的资源"
            }
          }
        },

        query_nogroup_resources: {
          url: "/api2/groups/none/resources",
          type: _.get,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string],
            type: [true, _.number],
            cursor: [false, _.number],
            limit: [false, _.number]
          },
          _desc: {
            zh: {
              name: "查询没有分组的资源"
            }
          }
        },

        assign_group_resources: {
          url: "/api2/groups",
          part: [true, _.string],
          suffix: "/resources",
          type: _.post,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string],
            type: [true, _.number]
          },
          data: {
            _required: true,
            resourceIds: [true, _.array]
          },
          _desc: {
            zh: {
              name: "给分组添加资源"
            }
          }
        },

        cancel_group_resources: {
          url: "/api2/groups",
          part: [true, _.string],
          suffix: "/resources",
          type: _.put,
          param: {
            _required: false,
            verbose: [false, _.number],
            oid: [false, _.string],
            type: [true, _.number]
          },
          data: {
            _required: true,
            resourceIds: [true, _.array]
          },
          _desc: {
            zh: {
              name: "删除分组下的资源"
            }
          }
        }

      }

    };

  }

});



//////////////////
// WEBPACK FOOTER
// ./cloud/base/model.structure.js
// module id = 15
// module chunks = 52